module.exports = __webpack_public_path__ + "img/add.ef1eb7f7.svg";